import { create } from 'zustand'

import { OrganizationStore } from './types'

// used to store the organization id
export const useOrganizationStore = create<OrganizationStore>(set => ({
  orgId: '',
  setOrgId: orgId => {
    set({ orgId })
  },
}))
